import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37db8537"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 16.8C13.5741 16.8 14.912 17.8106 15.4013 19.2178L15.4604 19.2084L15.6001 19.1999H22.8001C23.4629 19.1999 24.0001 19.7371 24.0001 20.3999C24.0001 21.0149 23.5369 21.5221 22.9397 21.5915L22.8001 21.5999H15.6001C15.5326 21.5999 15.466 21.5943 15.4013 21.5831C14.9119 22.9893 13.5741 23.9999 12 23.9999C10.4259 23.9999 9.08811 22.9892 8.59875 21.5821L8.53969 21.5915L8.4 21.5999H1.2C0.537192 21.5999 0 21.0627 0 20.3999C0 19.7849 0.463128 19.2777 1.06032 19.2084L1.20001 19.1999H8.40001C8.46751 19.1999 8.53407 19.2055 8.59875 19.2168C9.08814 17.8105 10.4259 16.8 12 16.8ZM12 19.2C11.3372 19.2 10.8 19.7372 10.8 20.4C10.8 21.0628 11.3372 21.6 12 21.6C12.6628 21.6 13.2 21.0628 13.2 20.4C13.2 19.7372 12.6628 19.2 12 19.2ZM3.60004 8.4C5.1741 8.4 6.51196 9.41062 7.00132 10.8178L7.06038 10.8084L7.20006 10.7999H22.8001C23.4629 10.7999 24.0001 11.3371 24.0001 11.9999C24.0001 12.6149 23.5369 13.1221 22.9397 13.1915L22.8001 13.1999H7.20006C7.13256 13.1999 7.066 13.1943 7.00131 13.1831C6.51192 14.5893 5.17412 15.5999 3.60003 15.5999C1.61158 15.5999 2.88e-05 13.9883 2.88e-05 11.9999C2.88e-05 10.0114 1.61158 8.39986 3.60003 8.39986L3.60004 8.4ZM3.60004 10.8C2.93723 10.8 2.40004 11.3372 2.40004 12C2.40004 12.6628 2.93723 13.2 3.60004 13.2C4.26284 13.2 4.80004 12.6628 4.80004 12C4.80004 11.3372 4.26284 10.8 3.60004 10.8ZM16.8 0C18.3741 0 19.712 1.01062 20.2013 2.41776L20.2604 2.40838L20.4001 2.39995H22.8001C23.4629 2.39995 24.0001 2.93714 24.0001 3.59995C24.0001 4.21495 23.5369 4.72214 22.9397 4.7915L22.8001 4.79994H20.4001C20.3326 4.79994 20.266 4.79431 20.2013 4.78306C19.7119 6.18932 18.3741 7.19986 16.8 7.19986C15.2259 7.19986 13.8881 6.18925 13.3987 4.7821L13.3397 4.79148L13.2 4.79991H1.2C0.537192 4.79991 0 4.26272 0 3.59991C0 2.98491 0.463128 2.47772 1.06032 2.40836L1.20001 2.39992H13.2C13.2675 2.39992 13.3341 2.40555 13.3988 2.4168C13.8881 1.01054 15.2259 0 16.8 0V0ZM16.8 2.4C16.1372 2.4 15.6 2.93719 15.6 3.6C15.6 4.26281 16.1372 4.8 16.8 4.8C17.4628 4.8 18 4.26281 18 3.6C18 2.93719 17.4628 2.4 16.8 2.4Z" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "search-wraper" }
const _hoisted_8 = {
  key: 0,
  class: "image-preview"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Searching for:", -1))
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ion_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, {
            size: "10",
            class: "ion-no-padding ion-padding-end ion-justify-content-between ion-align-items-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h1", null, [
                _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
                (_ctx.biometricActive)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(_ctx.pins.length) + ")", 1))
                  : _createCommentVNode("", true),
                (
								!_ctx.biometricActive &&
								(_ctx.totalFilteredPins || _ctx.totalPins)
							)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_ctx.totalFilteredPins || _ctx.totalPins) + ")", 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, { class: "ion-justify-content-between ion-align-items-center ion-text-end" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["filter-icon", _ctx.activeFilter ? 'filter-active' : ''])
              }, [
                (!_ctx.biometricActive)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openFilter()))
                    }, _hoisted_6))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_ion_searchbar, {
          class: _normalizeClass([
						_ctx.searchActive || !_ctx.canUseBiometry
							? ''
							: 'searchbar-border'
					, "ion-margin-top ion-no-padding"]),
          debounce: "500",
          modelValue: _ctx.filter,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter) = $event)),
          placeholder: "Search",
          onIonFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchActive = true)),
          onIonBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchActive = false))
        }, null, 8, ["class", "modelValue"]),
        (_ctx.canUseBiometry && _ctx.biometricActive)
          ? (_openBlock(), _createBlock(_component_ion_button, {
              key: 0,
              class: "cancel-biometric-btn",
              fill: "solid",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancelBiometricSearch()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cancel ")
              ]),
              _: 1
            }))
          : (
						false
					)
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 1,
                class: "biometric-btn",
                fill: "solid",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openImageSelect()))
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_ion_icon, {
                    class: "ion-padding-end",
                    icon: _ctx.camera
                  }, null, 8, ["icon"]), [
                    [_vShow, !_ctx.biometricActive]
                  ]),
                  _createTextVNode(" Picture search ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ]),
      (_ctx.image && _ctx.canUseBiometry && _ctx.biometricActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("img", {
              class: "searching-image",
              src: _ctx.image,
              alt: ""
            }, null, 8, _hoisted_10)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}